import { Autocomplete, TextField, Box, Typography, IconButton } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from '../styles/colors';
import { ReactComponent as Beach } from '../assets/icons/Beach.svg';
import { ReactComponent as ArrowDown } from '../assets/icons/ArrowDown.svg';
import CloseIcon from '@mui/icons-material/Close';
import useWindowWidth from '../hooks/useWindowWidth';

const useStyles = makeStyles<Theme, { windowWidth: number }>(() => ({
  paper: {
    boxShadow: '0 1px 6px -2px rgba(0,0,0,0.3) !important',
    background: colors.basics.white,
    borderRadius: "0 0 5px 5px !important",
    borderTop: `0.8px solid ${colors.grey[50]} !important`,
    // borderLeft: `1px solid transparent !important`,
    // borderRight: `1px solid transparent !important`,
    padding: ({ windowWidth }) => (windowWidth > 600 ? '10px 10px !important' : '4px !important'),
    maxHeight: '387px',
    // width: '100% !important',
    // minWidth: '308px !important',
    '& ul': {
      maxHeight: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& li': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingRight: '8px !important',
      paddingLeft: '8px !important',
      borderRadius: 5,
      fontFamily: 'Raleway',
      fontStyle: 'normal',
      fontWeight: 400,
      // i wnat to set 15 pc dor desktop and 14 for mobile using windowWidth
      fontSize: ({ windowWidth }) => (windowWidth > 600 ? '15px !important' : '14px !important'),
      lineHeight: '130%',
      color: colors.basics.black,
      '&:hover': {
        background: colors.basics.primary + '20 !important',
      },
    },
  },
}));
interface openModals {
  date: boolean,
  departure: boolean,
  destination: boolean,
  class: boolean,
  room: boolean,
}

interface autoCompleteProps {
  data: string[];
  value: string[] | string | any;
  StartIcon?: JSX.Element;
  disableClearable?: boolean;
  onChange: (e: string) => void;
  onInputChange?: (e: string) => void;
  style?: React.CSSProperties;
  keys?: keyof openModals | undefined;
  openModals?: openModals | undefined;
  setOpenModals?: (open: openModals) => void;
}

export default function AutoComplete(props: autoCompleteProps) {
  const { data, value = '', StartIcon, disableClearable, onChange, onInputChange, style, openModals, setOpenModals, keys } = props;
  const [open, setOpen] = React.useState(false);
  const [inputValue, setInputValue] = useState('')
  const [timer, setTimer] = useState<string | number | NodeJS.Timeout | null>(null)

  //! Variables
  const windowWidth = useWindowWidth();
  const classes = useStyles({ windowWidth });
  const onOpen = () => {
    // Prefill the input with the current value so the user can edit/clear it easily while the menu is open
    const stringValue = typeof value === 'string' ? value : '';
    setInputValue(stringValue);
    if (keys && openModals) {
      setOpenModals?.({
        ...openModals,
        [keys]: true
      })
    }

    setOpen(true)
    if (openModals === undefined || !openModals?.date) {
      let obj = { ...openModals } as openModals
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          obj[key as keyof openModals] = false;
        }
      }

      if (keys) {
        obj[keys] = true
      }

      setOpenModals?.(obj)
      const inputElement: Element | null = document.querySelector('.MuiAutocomplete-input');
      if (inputElement instanceof HTMLInputElement) {
        inputElement.addEventListener('click', () => {
          inputElement.select();
        })
      }
    }
  }

  const onClose = () => {
    if (keys && openModals) {
      setOpenModals?.({
        ...openModals,
        [keys]: false
      })
    }
    setOpen(false)
  }

  // Sync inputValue with value prop
  useEffect(() => {
    const stringValue = typeof value === 'string' ? value : '';
    if (stringValue && !open && !(keys && openModals !== undefined ? openModals[keys] : false)) {
      setInputValue(stringValue);
    }
  }, [value, open, keys, openModals]);

  const onInputChangeHandler = (newInputValue: string) => {
    timer !== null && clearTimeout(timer)
    setInputValue(newInputValue)
    // Call the parent's onInputChange callback if provided
    onInputChange?.(newInputValue)
    if (newInputValue === "") {
      const newTimer = setTimeout(() => {
        setInputValue(value)
      }, 1500)
      setTimer(newTimer)
    }
  }

  return (
    <Box sx={{
      '& .MuiPopper-root-MuiAutocomplete-popper ': {
        inset: "0px auto auto -1px #0000004D !important",
      },
      '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
        // border: `0.8px solid ${colors.grey[30]} !important`,
        // maxHeight: '41px !important',
        height: '100% !important',
        padding: '0px 8px !important',
        // boxShadow: keys && openModals !== undefined && openModals[keys] === true ? "none !important" : " #00000026 !important",

        // border: keys && openModals !== undefined && openModals[keys] === true ? "none !important" : `0.8px solid ${colors.grey[30]} !important`,
        borderBottom: keys && openModals !== undefined && openModals[keys] === true ? `0.8px solid transparent !important` : `0.8px solid ${colors.grey[30]} !important`,
        borderTop: keys && openModals !== undefined && openModals[keys] === true ? "0.8px solid transparent !important" : `0.8px solid ${colors.grey[30]} !important`,
        borderLeft: keys && openModals !== undefined && openModals[keys] === true ? "0.8px solid transparent !important" : `0.8px solid ${colors.grey[30]} !important`,
        borderRight: keys && openModals !== undefined && openModals[keys] === true ? "0.8px solid transparent !important" : `0.8px solid ${colors.grey[30]} !important`,
        // backgroundColor: keys && openModals !== undefined && openModals[keys] === true ? colors.basics.white : colors.basics.secondary,

      },

      '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
        padding: '10px 8px !important',
        fontSize: windowWidth > 576 ? "15px !important" : "14px !important",
        fontWeight: `${colors.grey[10]} !important`,
        lineHeight: '130% !important',
        color: `${colors.basics.black} !important`,
      },
      '& .MuiAutocomplete-root': {
        // I want to add top side box shadow not bottom side box shadow
        // boxShadow: `0px 0px 4px 0px #0000004D !important`,
        boxShadow: keys && openModals !== undefined && openModals[keys] === true ? "0px 0px 4px 0px #0000004D !important" : " none !important",
        backgroundColor: keys && openModals !== undefined && openModals[keys] === true ? colors.basics.white : colors.basics.secondary,
        borderRadius: keys && openModals !== undefined && openModals[keys] === true ? "5px 5px 0 0 !important" : "5px !important",
      },
      '& .MuiAutocomplete-option': {
        minHeight: '0 !important',
      },
      '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
        backgroundColor: "red !important",
      },
    }}>
      {(() => {
        const isFocused = keys && openModals !== undefined ? openModals[keys] : open;
        // When focused we always show the current input so the user can edit/clear it
        const effectiveInputValue = isFocused ? inputValue : '';

        return (
          <Autocomplete
            // freeSolo
            value={value}
            open={isFocused}
            onOpen={() => { onOpen() }}
            onClose={() => { onClose() }}
            disableClearable={disableClearable}
            popupIcon={<ArrowDown style={{ width: '14px', height: '14px' }} />}
            options={data?.map((option: {}) => option)}
            // loading={loading}
            // renderOption={(props, option) => (
            //   <Box component='li' {...props}>
            //     {option}
            //   </Box>
            // )}
            renderOption={(props, option) => {
              // Convert option to string if it's not already (assuming options are strings)
              const optionText = String(option);
              // Get the last 3 characters
              const lastThreeCharacters = optionText.slice(-3);
              // Get the rest of the string
              const restOfString = optionText.slice(0, -3);
              const index = data.indexOf(optionText);
              return (
                // i wnat to add heading in the render list as Destinations
                <Box key={index}>
                  <Box>
                    {/* for the first destination add heading as Destinations only once */}
                    {/* {index === 0 && (
                      <Typography variant='body1' mb='8px' fontSize={{ sm: '15px', xs: '14px' }} fontWeight={400} lineHeight='16px' color={colors.grey[10]}>
                        Destinations
                      </Typography>
                    )} */}

                  </Box>
                  <Box component='li' {...props} display='flex' alignItems='center'  >
                    {/* <Beach style={{ width: '18px', height: '18px', marginRight: '8px' }} /> */}
                    <span style={{ marginRight: "2px", fontSize: windowWidth < 576 ? "15px !important" : "14px !important" }}>{restOfString}</span>
                    <span style={{ fontWeight: "700", fontSize: windowWidth < 576 ? "15px !important" : "14px !important" }}>{`${lastThreeCharacters.toLocaleUpperCase()}`}</span>
                  </Box >
                </Box>
              );
            }}
            classes={{ paper: classes.paper }}
            onChange={(event, newValue) => {
              onChange(newValue)
              setInputValue(newValue)
            }}
            inputValue={effectiveInputValue}
            onInputChange={(event, newInputValue) => { onInputChangeHandler(newInputValue) }}
            sx={{
              pointerEvents: openModals?.date ? "none" : "",
              width: '100%',
              background: colors.basics.white,
              '& .MuiInputBase-root-MuiOutlinedInput-root.MuiOutlinedInput-root': {
                border: `0.8px solid red !important`,
                maxHeight: '41px',
                height: '100%',
              },
              '& .MuiOutlinedInput-input': {
                fontSize: windowWidth < 576 ? "15px" : "14px",
                paddingLeft: '0px !important',
                paddingRight: '0px !important',
                textOverflow: "ellipsis",
                // border: `0.8px solid ${colors.grey[20]}`,
              },
              '& .MuiOutlinedInput-root.MuiOutlinedInput-root fieldset': {
                border: 'none !important',
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  // borderColor: keys && openModals !== undefined && openModals[keys] === true ? colors.basics.black : colors.grey[30],
                },
                "&.Mui-focused fieldset": {
                  // borderColor: keys && openModals !== undefined && openModals[keys] === true ? colors.basics.black : colors.grey[30],
                },
              },
              ...style,
            }
            }
            renderInput={(params) => {
              // const showCloseIcon = hasValue;
              const showCloseIcon = false;

              // Get the current input value and split it for bold styling
              const displayValue = typeof value === 'string' ? value : '';
              const currentValue = displayValue; // Always use displayValue for overlay since input is empty when overlay shows
              const normalText = currentValue.length > 3 ? currentValue.slice(0, -3) : currentValue;
              const boldText = currentValue.length > 3 ? currentValue.slice(-3) : '';
              const isFocused = keys && openModals !== undefined ? openModals[keys] : open;
              // Show overlay only when not focused so the actual input stays editable while open
              const showOverlay = currentValue && currentValue.length > 0 && !isFocused;

              return (
                <Box sx={{ position: 'relative', width: '100%' }}>
                  <TextField
                    {...params}
                    type='text'
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: StartIcon ? (
                        <Box display='flex' sx={{ marginRight: { sm: '2px', xs: '5px' }, marginLeft: { sm: '4px', xs: '5px' } }}>
                          {StartIcon}
                        </Box>
                      ) : null,
                      endAdornment: showCloseIcon ? (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onChange('');
                            setInputValue('');
                          }}
                          sx={{
                            padding: '4px',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <CloseIcon sx={{ fontSize: '20px', color: colors.basics.black }} />
                        </IconButton>
                      ) : params.InputProps.endAdornment,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        color: showOverlay ? 'transparent' : 'inherit',
                        caretColor: showOverlay ? 'transparent' : (isFocused ? colors.basics.black : 'transparent'),
                      },
                    }}
                  />
                  {showOverlay && (
                    <Box
                      sx={{
                        position: 'absolute',
                        left: StartIcon ? (windowWidth < 576 ? '45px' : '38px') : '14px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        fontSize: windowWidth < 576 ? "15px" : "14px",
                        lineHeight: '130%',
                        color: colors.basics.black,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: 'calc(100% - 80px)',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {normalText}
                      <strong style={{ fontWeight: 700, marginLeft: "4px" }}>{boldText}</strong>
                    </Box>
                  )}
                </Box>
              );
            }}
          />
        );
      })()}
    </Box>
  );
}
